export const isNumberEqual = (
	a: number = 0,
	b: number = 0,
	decimal: number = 3,
) => {
	if ( Number.isNaN( a ) || Number.isNaN( b ) ) return false;
	return Math.abs( a * Math.pow( 10, decimal ) - b * Math.pow( 10, decimal ) ) <= 1;
};
